import { CheckBox } from '@iwoca/orion';
import { useFormContext } from 'react-hook-form';
import { FieldError } from '../FieldError/FieldError';
import { TRegistrationFormValues } from '../registrationForm.types';
import styles from './TermsAndConditions.module.css';

export const TermsAndConditions = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<TRegistrationFormValues>();

  return (
    <div className={styles.privacyPolicyContainer}>
      <CheckBox
        {...register('privacyPolicyAgreement')}
        id="privacyPolicyAgreement"
        name="privacyPolicyAgreement"
        data-testid="privacy-policy-agreement"
      />
      <div className={styles.privacyPolicyDescription}>
        <p>
          <strong>
            I agree to iwoca carrying out due diligence on the company I
            represent and understand that iwoca will contact me for signature on
            the iwoca introducer agreement.
          </strong>
        </p>

        <p>
          Your privacy is important to us at iwoca, and we're committed to
          protecting your personal data. We'll store your personal data
          securely, and we'll only get in touch in line with our{' '}
          <a
            href="https://www.iwoca.co.uk/introducer-privacy-policy/"
            target="_blank"
            rel="noreferrer"
          >
            privacy policy
          </a>{' '}
          or if you opt in for extra communication from us.
        </p>
        <FieldError errorMessage={errors?.privacyPolicyAgreement?.message} />
      </div>
    </div>
  );
};
